import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, AlertCircle } from "lucide-react";

export default function FirstVisitPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("h1h1_popup_seen");
    if (!seen) {
      setVisible(true);
      localStorage.setItem("h1h1_popup_seen", "1");
      const timer = setTimeout(() => setVisible(false), 15000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.35 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-2rem)] max-w-md"
        >
          <div className="bg-red-600 text-white rounded-2xl shadow-2xl px-5 py-4 flex items-start gap-3">
            <AlertCircle className="w-6 h-6 flex-shrink-0 mt-0.5" />
            <p className="text-sm font-medium leading-snug flex-1">
              Is your website down? Can't get ahold of your current provider?{" "}
              <a href="sms:+13603892897" className="font-bold underline underline-offset-2">Text us at 360.389.2897.</a>
            </p>
            <button
              onClick={() => setVisible(false)}
              className="flex-shrink-0 hover:opacity-75 transition-opacity"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}